import pluralize from 'pluralize'

export const COMMENT_LABELS = {
  edited: '(edited)',
  deleteConfirm: 'Delete this comment?',
  deleteIrreversible: 'This can’t be undone.',
  linkCopied: 'Link copied',
  addReaction: 'Add reaction',
  loadError: 'Couldn’t load comments. Please try again.',
  unknownAuthor: 'Unknown user',
  reactedWith: 'reacted with',
} as const

export const otherReactorsLabel = (count: number) => `and ${pluralize('other', count, true)}`
